import { styled } from '@linaria/react';

export const FrontPageBtnList = styled.div`
    display: grid;
    grid-template-columns: repeat(9, 1fr);
    gap: 0;
    background: white;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    padding: 4px;
    margin: 10px 0;

    @media (max-width: 1250px) {
        margin: 10px 1rem;
        gap: 4px;
    }

    @media (max-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
        gap: 6px;
        margin: 10px 1rem;
    }

    @media (max-width: 480px) {
        grid-template-columns: 1fr;
        gap: 8px;
    }
`;

export const FrontPageLinkUnit = styled.div`
    background: #f8f9fa;
    border: none;
    border-radius: 2px;
    padding: 6px 2px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
    color: inherit;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h4 {
        margin: 6px 0 0 0;
        font-size: 0.65rem;
        font-weight: 500;
        color: #495057;
        text-transform: uppercase;
        letter-spacing: 0.2px;
        line-height: 1.1;
        text-align: center;
    }

    &:hover {
        background: #e9ecef;
        transform: translateY(-2px);
        text-decoration: none;
        color: inherit;

        div {
            opacity: 1;
        }

        h4 {
            color: #343a40;
        }
    }

    &.active {
        background: #dee2e6;

        h4 {
            color: #495057;
        }
    }

    div {
        width: 95px;
        height: 95px;
        margin: 0 auto 4px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        opacity: 0.8;
        transition: opacity 0.2s ease;
        border-radius: 4px;
        border: 1px solid #d3d3d3;
    }

    &#front-page-conversion-tools div {
        background-image: url('/assets/images/calculator.jpg');
    }

    &#front-page-ibc-code div {
        background-image: url('/assets/images/ibc_code.JPG');
    }

    &#front-page-uscg div {
        background-image: url('/assets/images/uscg2.jpg');
    }

    &#front-page-fosfa-niop-eu div {
        background-image: url('/assets/images/fosfa.jpg');
    }

    &#front-page-rgm div {
        background-image: url('/assets/images/odfjell.jpg');
    }

    &#front-page-external-links div {
        background-image: url('/assets/images/external_links.png');
    }

    &#front-page-cargo-related div {
        background-image: url('/assets/images/marpol.jpg');
    }

    &#front-page-cleaning-chemicals div {
        background-image: url('/assets/images/cleaning_chemicals.png');
    }

    &#front-page-training-materials div {
        background-image: url('/assets/images/training_materials.png');
    }

    @media (max-width: 480px) {
        min-height: 80px;
        padding: 20px 15px;

        h4 {
            font-size: 0.85rem;
        }

        div {
            width: 36px;
            height: 36px;
        }
    }
`;

export const FrontPageLinkUnitAnchor = styled.a`
    background: #f8f9fa;
    border: none;
    border-radius: 2px;
    padding: 6px 2px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
    text-decoration: none;
    color: inherit;
    min-height: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h4 {
        margin: 6px 0 0 0;
        font-size: 0.65rem;
        font-weight: 500;
        color: #495057;
        text-transform: uppercase;
        letter-spacing: 0.2px;
        line-height: 1.1;
        text-align: center;
    }

    &:hover {
        background: #e9ecef;
        transform: translateY(-2px);
        text-decoration: none;
        color: inherit;

        div {
            opacity: 1;
        }

        h4 {
            color: #343a40;
        }
    }

    div {
        width: 95px;
        height: 95px;
        margin: 0 auto 4px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        opacity: 0.8;
        transition: opacity 0.2s ease;
        border-radius: 4px;
        border: 1px solid #d3d3d3;
        background-image: url('/assets/images/calculator.jpg');
    }

    @media (max-width: 480px) {
        min-height: 80px;
        padding: 20px 15px;

        h4 {
            font-size: 0.85rem;
        }

        div {
            width: 36px;
            height: 36px;
        }
    }
`;

export const FrontPageContent = styled.div`
    margin-top: 30px;

    h3 {
        color: #333;
        font-size: 1.5rem;
        margin-bottom: 15px;
        border-bottom: 2px solid #0066cc;
        padding-bottom: 10px;
    }

    p {
        color: #666;
        line-height: 1.6;
        margin-bottom: 15px;
    }
`;
